import { z } from 'zod';
import {
  elementInstanceDomain,
  pageDomain,
  sectionDomain,
  sectionRefDomain,
} from '../model';

export const clipboardPayloadSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('page'),
    state: pageDomain.stateSchema,
    globalSections: z.record(sectionDomain.stateSchema).default({}),
  }),
  z.object({
    type: z.literal('section-ref'),
    state: sectionRefDomain.stateSchema,
    globalSections: z.record(sectionDomain.stateSchema).default({}),
  }),
  z.object({
    type: z.literal('element'),
    state: elementInstanceDomain.stateSchema,
  }),
]);
export type ClipboardPayload = z.infer<typeof clipboardPayloadSchema>;
